import { computed } from "vue";
import { useModifiers } from "./useModifiers";

export const typePropNames = ["type"];
export const typeValues = Object.freeze([
  "display",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "body-large",
  "body-medium",
  "body",
  "body-semi-bold",
  "body-bold",
  "link",
  "small",
  "small-bold",
  "footnote",
  "footnote-medium",
  "footnote-bold",
]);

export const typographyProps = {
  type: {
    type: String,
    default: undefined,
    validator: (value) => typeValues.includes(value),
  },
};

export function useTypography(props) {
  const { modifiers } = useModifiers(props, ...typePropNames);
  const typographyModifiers = computed(() => modifiers.value);

  return {
    typographyModifiers,
  };
}
